'use client';

// Figma node 1824:7283 — Bottom Navbar
// Assets valid for 7 days from design export; replace with CDN-hosted URLs for production
// imgSubtract: Figma node 1824:7319 — the curved-notch background shape
import { c as _c } from "react/compiler-runtime";
import { trackAnalyticsEvent } from '@/lib/analytics';
interface BottomNavbarProps {
  onTap: (source?: string) => void;
}
export function BottomNavbar(t0) {
  const $ = _c(23);
  const {
    onTap
  } = t0;
  let t1;
  if ($[0] !== onTap) {
    t1 = () => {
      trackAnalyticsEvent("HOME_BUTTON_CLICKED_WEB");
      onTap("home_button");
    };
    $[0] = onTap;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M21.0913 8.88528L13.5917 2.58139C13.1463 2.20593 12.5826 2 12.0002 2C11.4177 2 10.854 2.20593 10.4087 2.58139L2.90878 8.88544C2.62303 9.12632 2.39357 9.42714 2.23657 9.7663C2.07956 10.1055 1.99884 10.4749 2.00008 10.8487V19.4545C1.99485 20.1233 2.25511 20.767 2.72378 21.2442C3.19245 21.7214 3.83125 21.9932 4.50006 22H19.4999C20.1687 21.9932 20.8076 21.7214 21.2762 21.2442C21.7449 20.767 22.0052 20.1233 21.9999 19.4545V10.8487C22.0012 10.4749 21.9205 10.1053 21.7635 9.76612C21.6065 9.42689 21.3771 9.12621 21.0913 8.88528ZM15.3333 17.8331H8.66669C8.44568 17.8331 8.23372 17.7453 8.07744 17.589C7.92116 17.4327 7.83337 17.2207 7.83337 16.9997C7.83337 16.7787 7.92116 16.5667 8.07744 16.4104C8.23372 16.2541 8.44568 16.1663 8.66669 16.1663H15.3333C15.5543 16.1663 15.7663 16.2541 15.9226 16.4104C16.0788 16.5667 16.1666 16.7787 16.1666 16.9997C16.1666 17.2207 16.0788 17.4327 15.9226 17.589C15.7663 17.7453 15.5543 17.8331 15.3333 17.8331Z" fill="url(#paint0_linear_1824_7289)" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative w-6 h-6 shrink-0 overflow-hidden"><svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}<defs><linearGradient id="paint0_linear_1824_7289" x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse"><stop offset="0.18" stopColor="#FFBA27" /><stop offset="0.97" stopColor="#FFA700" /></linearGradient></defs></svg></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-[12px] leading-[1.3] opacity-[0.86] text-center w-[70px] bg-clip-text text-transparent" style={{
      backgroundImage: "linear-gradient(to bottom, #ffba27 18%, #ffa700 97%)"
    }}>Home</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <button onClick={t1} className="flex flex-1 flex-col gap-[6px] items-center py-[12px]" aria-label="Home">{t3}{t4}</button>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onTap) {
    t6 = () => {
      trackAnalyticsEvent("PAYMENT_PAGE_BUTTON_CLICKED_WEB");
      onTap("payment_page_button");
    };
    $[7] = onTap;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      background: "linear-gradient(to bottom, #ffba27 18%, #ffa700 97%)"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="w-[48px] h-[48px] rounded-full bg-[rgba(178,118,0,0.75)] flex items-center justify-center overflow-hidden"><div className="w-[40px] h-[40px] rounded-full flex items-center justify-center overflow-hidden" style={t7}><div className="relative w-[22px] h-[24px] overflow-hidden"><svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.92085 6.87368H0C0.0481987 6.68778 0.1377 6.50882 0.261623 6.35044L3.4699 2.34356C3.53184 2.26784 3.59382 2.2059 3.66954 2.15081L5.92085 6.87368ZM0 7.56215C0.0344587 7.75494 0.12396 7.93391 0.247879 8.09918L10.8847 21.7928C10.988 21.9305 11.1119 22.0406 11.2496 22.1233L6.21687 7.56216L0 7.56215ZM11.5043 1.82031H4.57143C4.47504 1.82031 4.38558 1.82721 4.28918 1.84788L6.56801 6.63273L11.5043 1.82031ZM16.6953 6.87368L15.2496 5.46233L12 2.29536L7.30467 6.87368H16.6953ZM6.94665 7.56215L12 22.1783L17.0534 7.56215H6.94665ZM19.6971 1.84788C19.6076 1.82721 19.5112 1.82031 19.4217 1.82031H12.4957L17.432 6.63958L19.6971 1.84788ZM12.7435 22.1232C12.8812 22.0406 13.0052 21.9305 13.1084 21.7928L23.7521 8.09917C23.8761 7.9339 23.9656 7.75494 24 7.56214H17.7831L12.7435 22.1232ZM24 6.87368C23.9518 6.68778 23.8623 6.50882 23.7384 6.35044L20.5232 2.34356C20.4613 2.26784 20.3993 2.2059 20.3236 2.15081L18.086 6.87368H24Z" fill="black" /></svg></div></div></div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6) {
    t9 = <button onClick={t6} className="flex flex-col gap-[6px] items-center justify-end h-[46px] w-[71px] shrink-0" aria-label="Play">{t8}</button>;
    $[11] = t6;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== onTap) {
    t10 = () => {
      trackAnalyticsEvent("MYLIST_BUTTON_CLICKED_WEB");
      onTap("my_list");
    };
    $[13] = onTap;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="relative w-[24px] h-[24px] shrink-0 overflow-hidden"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clip-rule="evenodd" d="M13.5 18.9217L8.68575 22.3605C8.457 22.5232 8.15625 22.5457 7.9065 22.4167C7.65675 22.2885 7.5 22.0312 7.5 21.75V7.5C7.5 6.258 8.508 5.25 9.75 5.25H17.25C18.492 5.25 19.5 6.258 19.5 7.5V21.75C19.5 22.0312 19.3433 22.2885 19.0935 22.4167C18.8438 22.5457 18.543 22.5232 18.3143 22.3605L13.5 18.9217ZM18 20.2927V7.5C18 7.086 17.664 6.75 17.25 6.75H9.75C9.336 6.75 9 7.086 9 7.5V20.2927L13.0643 17.3895C13.3245 17.2035 13.6755 17.2035 13.9357 17.3895L18 20.2927Z" fill="#A0A0AB" /><path fillRule="evenodd" clip-rule="evenodd" d="M6 17.4645C6.234 17.4645 6.46425 17.574 6.6105 17.778C6.85125 18.1155 6.7725 18.5842 6.43575 18.8242L5.68575 19.3605C5.457 19.5232 5.15625 19.5457 4.9065 19.4167C4.65675 19.2885 4.5 19.0312 4.5 18.75V3.75C4.5 2.508 5.508 1.5 6.75 1.5H14.25C15.492 1.5 16.5 2.508 16.5 3.75C16.5 4.164 16.164 4.5 15.75 4.5C15.336 4.5 15 4.164 15 3.75C15 3.336 14.664 3 14.25 3H6.75C6.336 3 6 3.336 6 3.75V17.4645Z" fill="#A0A0AB" /></svg></div>;
    t12 = <span className="text-[#a0a0ab] text-[12px] leading-[1.3] opacity-[0.86] text-center">My List</span>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t11 = $[15];
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10) {
    t13 = <button onClick={t10} className="flex flex-1 flex-col gap-[6px] items-center py-[12px]" aria-label="My List">{t11}{t12}</button>;
    $[17] = t10;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t5 || $[21] !== t9) {
    t14 = <div className="flex-shrink-0 w-full relative h-[70px]"><div className="relative flex gap-[4px] items-start justify-center w-full">{t5}{t9}{t13}</div></div>;
    $[19] = t13;
    $[20] = t5;
    $[21] = t9;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
}